<script setup lang="ts">
import ResetPassword  from '@/components/AccountForms/ResetPassword.vue';
import ProfileUpdate from '@/components/AccountForms/ProfileUpdate.vue';

const authStore = useAuth();
const { user } = storeToRefs(authStore);

const userData = computed(() => user.value);

const userUpdateData = computed(() => ({
  firstName: userData.value?.firstname ?? '',
  lastName: userData.value?.lastname ?? '',
  id_gender: userData.value?.id_gender ?? '',
  email: userData.value?.email ?? '',
}));
</script>

<template>
  <Navigation>
    <Tabs
      :tabs="[
        { label: $t('Personal data'), handle: 'update' },
        { label: $t('Password change'), handle: 'change' },
      ]"
    >
      <template v-slot="{ activeTab }">
        <component
          :is="activeTab.handle === 'update' ? ProfileUpdate : ResetPassword"
          v-bind="activeTab.handle === 'update' ? userUpdateData : {}"
        />
      </template>
    </Tabs>
  </Navigation>
</template>
